import React, { useState, useEffect } from 'react';
import { TextInput, InputWrapper } from '../../../components/inputs';
import { handleChange } from '../../../../core/utils/utils';
import { validateForm } from '../../../../core/form/formValidationRules';
import { ComplaintFormPresentationProps } from '../../../../core/Interface/frontend/complaintFormPresentationInterface';

const ComplaintFormPresentation: React.FC<ComplaintFormPresentationProps> = ({
  formData,
  errors: parentErrors,
  loading,
  requestError,
  successRequest,
  validationRules,
  createComplaint,
}) => {
  const [complaintData, setComplaintData] = useState(formData);
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    setErrors(parentErrors);
  }, [parentErrors]);

  // useEffect(() => {
  //   if (Object.keys(errors).length > 0) {
  //     const validationErrors = validateForm(complaintData, validationRules || [], {}, new Date());
  //     setErrors(validationErrors);
  //   }
  // }, [complaintData]);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    const fieldValidationRules = validationRules?.filter(rule => rule.field === name) || [];
    const validationErrors = validateForm({ [name]: value }, fieldValidationRules, {}, new Date());

    console.debug(validationErrors)

    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: validationErrors[name] || '',
    }));
  };


  // Validar reactivamente en cada cambio de input
  const handleInputChange = (e: any) => {
    handleChange(e, setComplaintData);
  };

  const handleCreateComplaint = async (e: any) => {
    createComplaint(e, complaintData);
  };

  return (
    <div className="card-body">
      <form onSubmit={handleCreateComplaint}>
        <div className="section-header bg-light p-2 mb-3">
          <h5 className="mb-0">1. IDENTIFICACIÓN DEL CONSUMIDOR RECLAMANTE</h5>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <TextInput
              label="NOMBRE COMPLETO"
              value={complaintData.fullName}
              onChange={handleInputChange}
              error={errors?.fullName}
              onBlur={handleBlur}
              name="fullName"
              placeholder="Ingrese su nombre completo"
              required
            />
          </div>
          <div className="col-md-6">
            <TextInput
              label="DOMICILIO"
              value={complaintData.address}
              onChange={handleInputChange}
              error={errors?.address}
              onBlur={handleBlur}
              name="address"
              placeholder="Ingrese su dirección"
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <TextInput
              label="NÚMERO DE DNI O CEDULA"
              value={complaintData.dniOrCe}
              onChange={handleInputChange}
              error={errors?.dniOrCe}
              onBlur={handleBlur}
              name="dniOrCe"
              placeholder="Ingrese número de documento"
              required
            />
          </div>
          <div className="col-md-6">
            <TextInput
              label="TELÉFONO / E-MAIL"
              value={complaintData.phoneOrEmail}
              onChange={handleInputChange}
              error={errors?.phoneOrEmail}
              onBlur={handleBlur}
              name="phoneOrEmail"
              placeholder="Ingrese su número de teléfono"
              required
            />
          </div>
        </div>

        {complaintData.isMinor && (
          <div className="row mb-3">
            <div className="col-md-12">
              <TextInput
                label="PADRE O MADRE (PARA EL CASO DE MENORES DE EDAD)"
                value={complaintData.tutorFullName || ''}
                onChange={handleInputChange}
                error={errors?.tutorFullName}
                onBlur={handleBlur}
                name="tutorFullName"
                placeholder="Ingrese nombre del padre o madre"
                required
              />
            </div>
          </div>
        )}

        <div className="mb-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="isMinor"
              checked={complaintData.isMinor}
              onChange={handleInputChange}
              id="isMinorCheck"
            />
            <label className="form-check-label" htmlFor="isMinorCheck">
              Soy menor de edad
            </label>
          </div>
        </div>

        {/* Sección 2: Identificación del Bien Contratado */}
        <div className="section-header bg-light p-2 mb-3">
          <h5 className="mb-0">2. IDENTIFICACIÓN DEL BIEN CONTRATADO</h5>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <InputWrapper
                label="PRODUCTO / SERVICIO"
                error={errors?.productOrService}
                required
              >
                <div className="d-flex">
                  <div className="form-check me-4">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="productOrService"
                      value="PRODUCTO"
                      onBlur={handleBlur}
                      checked={complaintData.productOrService === 'PRODUCTO'}
                      onChange={handleInputChange}
                      id="productType"
                    />
                    <label className="form-check-label" htmlFor="productType">
                      Producto
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="productOrService"
                      value="SERVICIO"
                      onBlur={handleBlur}
                      checked={complaintData.productOrService === 'SERVICIO'}
                      onChange={handleInputChange}
                      id="serviceType"
                    />
                    <label className="form-check-label" htmlFor="serviceType">
                      Servicio
                    </label>
                  </div>
                </div>
              </InputWrapper>
            </div>
          </div>
          <div className="col-md-6">
            <TextInput
              label="MONTO RECLAMADO"
              value={complaintData.totalAmount}
              onChange={handleInputChange}
              error={errors?.totalAmount}
              onBlur={handleBlur}
              name="totalAmount"
              placeholder="Ingrese el monto"
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <TextInput
              label="DESCRIPCIÓN"
              value={complaintData.description}
              onChange={handleInputChange}
              error={errors?.description}
              onBlur={handleBlur}
              name="description"
              placeholder="Describa el producto o servicio"
              required
            />
          </div>
        </div>

        {/* Sección 3: Detalle de la Reclamación y Pedido del Consumidor */}
        <div className="section-header bg-light p-2 mb-3">
          <h5 className="mb-0">3. DETALLE DE LA RECLAMACIÓN Y PEDIDO DEL CONSUMIDOR</h5>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <div className="form-group">
              <InputWrapper
                label="TIPO"
                error={errors?.complaintOrClaim}
                required
              >
                <div className="d-flex">
                  <div className="form-check me-4">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="complaintOrClaim"
                      value="RECLAMO"
                      onBlur={handleBlur}
                      checked={complaintData.complaintOrClaim === 'RECLAMO'}
                      onChange={handleInputChange}
                      id="reclamoType"
                    />
                    <label className="form-check-label" htmlFor="reclamoType">
                      Reclamo¹
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="complaintOrClaim"
                      value="QUEJA"
                      onBlur={handleBlur}
                      checked={complaintData.complaintOrClaim === 'QUEJA'}
                      onChange={handleInputChange}
                      id="quejaType"
                    />
                    <label className="form-check-label" htmlFor="quejaType">
                      Queja²
                    </label>
                  </div>
                </div>
              </InputWrapper>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <div className="form-group">
              <InputWrapper
                label="DETALLE"
                error={errors?.detail}
                required
              >
                <textarea
                  className="form-control"
                  rows={4}
                  name="detail"
                  value={complaintData.detail}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  placeholder="Ingrese los detalles de su reclamo o queja"
                ></textarea>
              </InputWrapper>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <div className="form-group">
              <InputWrapper
                label="PEDIDO"
                error={errors?.order}
                required
              >
                <textarea
                  className="form-control"
                  rows={4}
                  name="order"
                  value={complaintData.order}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  placeholder="Ingrese su solicitud o pedido"
                ></textarea>
              </InputWrapper>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <div className="alert alert-secondary">
              <small>
                <strong>¹RECLAMO:</strong> Disconformidad relacionada a los productos o servicios.<br />
                <strong>²QUEJA:</strong> Disconformidad no relacionada a los productos o servicios; o, malestar o descontento respecto a la atención al público.
              </small>
            </div>
          </div>
        </div>

        {requestError && (
          <div className="alert alert-danger" role="alert">
            {requestError ? requestError : 'Error al enviar el reclamo'}
          </div>
        )}

        {successRequest && (
          <div className="alert alert-success" role="alert">
            Reclamo enviado con éxito.
          </div>
        )}

        <div className="d-flex justify-content-end align-items-center">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Enviando..." : "Enviar Reclamo"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ComplaintFormPresentation;